export default {
    agreement_print: "Печать согласия",
    agreement_template: "Шаблон соглашения",
    agreements: "Соглашения",
    are_you_sure_you_want_to_delete_template: "Вы уверены, что хотите удалить шаблон?",
    bite_templates: "Прикус",
    choose_fields_for_autocomplete: "Выберите необходимые значения для автозаполнения:",
    complaints_templates: "Жалобы",
    consents: "Согласия",
    contract_template: "Шаблон договора",
    contracts: "Договоры",
    development: "Развитие",
    development_templates: "Развитие",
    diseases: "Болезни",
    diseases_templates: "Болезни",
    document_template_word_file_note: "Вы можете прикрепить файл word в качестве шаблона. В файле word необходимо помечать тэги знаком $ и фигурными скобками и использовать только заглавные буквы. Например: ${FIO_CLIENT}.",
    epikriz_templates: "Эпикриз",
    found_templates_with_diagnosis: "Найдено шаблонов с диагнозами",
    full_treatment_template: "Шаблон лечения",
    general_template: "Шаблон",
    generate: "Сформировать",
    generated: "Сформирован",
    inspection_templates: "Осмотр",
    medication_templates: "Лечение",
    not_generated: "Не сформирован",
    objectively_templates: "Объективно",
    plan_treatment_template: "Шаблон плана лечения",
    plansurvey: "План обследования",
    plansurvey_templates: "План обследования",
    recommendations_templates: "Рекомендации",
    refresh_status_in: "Обновить статус в {vendor}",
    research: "Данные исследований",
    research_templates: "Данные исследований",
    researches: "Исследования",
    see_in_onlinecontract: "Посмотреть в OnlineContract",
    see_in_trustme: "Посмотреть в TrustMe",
    see_in_vendor: "Посмотреть в {vendor}",
    sign_via_onlinecontract: "Подписать через OnlineContract",
    sign_via_trustme: "Подписать через TrustMe",
    sign_via_vendor: "Подписать через {vendor}",
    signed: "Подписан",
    signed_via_onlinecontract: "Подписан через OnlineContract",
    signed_via_trustme: "Подписан через TrustMe",
    standard_diagnoses: "Стандартные диагнозы",
    subjectively_templates: "Субъективно",
    teeth_medication: "Лечение",
    teeth_plansurvey: "План обследования",
    teeth_recommendations: "Рекомендации",
    templates_treatments_categories: "Категории шаблонов лечений",
    upload_signed: "Загрузить подписанный",
    uploaded: "Загружен"
}
